import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

interface NameFieldsWrapperProps {
    columns: number;
}

export const NameFieldsWrapper = styled.div<NameFieldsWrapperProps>`
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns},1fr)`};
    gap: 1rem;
    margin-bottom: 1rem;

    @media (max-width: 789px) {
        grid-template-columns: ${({ columns }) => `repeat(${columns === 4 ? 3 : columns}, 1fr)`};
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        grid-template-columns: ${({ columns }) => `repeat(${columns === 1 ? 1 : 2}, 1fr)`};
    }
`;

export const CustomerCardFooter = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 1.714rem;
    margin-bottom: 1.714rem;
`;

interface LoadingIndicatorWrapperProps {
    isFullHeight?: boolean;
}

export const LoadingIndicatorWrapper = styled.div<LoadingIndicatorWrapperProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: ${({ isFullHeight = true }) => (isFullHeight ? '80vh' : 'auto')};
`;
